# Scroll-Navigation
window.onscroll = ->
  if window.XMLHttpRequest
    if document.documentElement.scrollTop > 550 or self.pageYOffset > 550
      $('.scroll-nav').css 'top', '0px'
    else if document.documentElement.scrollTop < 550 or self.pageYOffset < 550
      $('.scroll-nav').css 'top', '-50%'
  return

# Mobile-Navigation
closeMenu = undefined
isAnimating = undefined
isOpen = undefined
openMenu = undefined
isOpen = false
isAnimating = false

openMenu = ->
  if isAnimating
    return
  isAnimating = true
  $('.main-nav').animate { left: '0px' }, 650, ->
    isOpen = true
    isAnimating = false
    return
  return

closeMenu = ->
  if isAnimating
    return
  isAnimating = true
  $('.main-nav').animate { left: '-375px' }, 650, ->
    isOpen = false
    isAnimating = false
    return
  return

$ ->
  $('#menu-button').click ->
    if isOpen
      closeMenu()
    else
      openMenu()
    return
  return



// WEBPACK FOOTER //
// ./Components/navigation.coffee